import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=fce02686&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=fce02686&prod&scoped=true&lang=scss"
import style1 from "./Admin.vue?vue&type=style&index=1&id=fce02686&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce02686",
  null
  
)

export default component.exports